import apiService from './apiService'

export const requestCreateShift = (payload) => {
  return apiService.post(URIS.campaignShift, payload)
}

export const requestListShift = () => {
  return apiService.get(URIS.campaignShift)
}

export const requestUpdateShifts = ({ campaignId,  payload}) => {
  return apiService.get(URIS_D('getBookings', campaignId), payload)
}

export const requestDeleteShifts = (shiftId) => {
  return apiService.delete(
    URIS_D('shiftEditDelete',shiftId))
}

export const requestEditShift = ({shiftId, data}) => {
  return apiService.patch(
    URIS_D('shiftEditDelete',shiftId), data)
}

export const requestShiftAppointments = (payload) => {
  return apiService.get(URIS_D('shiftJobs', payload));
}

const URIS_D = (url, param1 = '') => {
  return {
    getBookedShift: `/v1/campaigns/${param1}/shifts`,
    shiftEditDelete: `/v1/campaigns/shifts/${param1}`,
    shiftJobs: `/v1/campaigns/shifts/${param1}/campaign-appointments`
  }[url]
}

const URIS = {
  campaignShift: '/v1/campaigns/shifts',
}
